enum LevelNodeState {
    COMPLETE,
    CURRENT,
    FUTURE,
}
export default LevelNodeState;
